
import _ from "lodash";
import Vue from "vue";

import { Order } from "@/model/entity/order";
import { TmpOrder } from "@/model/entity/tmp_order";
import { Acknowledged, MinCustomerViolation, StockShortage } from "@/model/shop/acknowledgeStock";
import { CategoryOptionRow, MatchedOrderRow } from "@/model/shop/table_session/startCategoryOption";
import { toMatchedOrdersPayload } from "@/components/compositions/categoryOptionConfirm";
import CategoryOptionConfirm from "@/components/compositions/CategoryOptionConfirm.vue";

import ShopAPI from "../../common/api/api_shop";
import notificationMixin from "../../mixin/notification";
import { OrderCode } from "../../model/entity/orderSetting";
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import store from "../../store/shop";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

export default Vue.component("Cart", {
  components: {
    QButton: () => import("../../components/elements/QButton.vue"),
    SHCartCardSkeleton: () =>
      import("../../components/components/SHCartCardSkeleton.vue"),
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
    QRemainMenuOption: () =>
      import("../../components/elements/QRemainMenuOption.vue"),
    QCartListTotal: () =>
      import("../../components/elements/QCartListTotal.vue"),
    CategoryOptionConfirm,
  },
  filters: {
    priceFilter(price: number): string {
      if (Number.isNaN(price)) return "0";
      const formatter = new Intl.NumberFormat("ja-JP");

      return formatter.format(price);
    },
    taxPrice(prices): number {
      if (prices.tanka.exclude !== null) {
        return prices.tanka.exclude;
      }
      return prices.tanka.include;
    },
    taxTotal(prices): number {
      if (prices.total.exclude !== null) {
        return prices.total.exclude;
      }
      return prices.total.include;
    },
    numberFormat(number) {
      if (typeof number !== "number") {
        return number;
      }
      return number.toLocaleString();
    },
  },
  mixins: [notificationMixin],
  data() {
    return {
      orders: [],
      tableSessionId: this.$route.params.table_session_id,
      isNaizei: "",
      isQuick: "",
      isDeliver: "0",
      listTotal: [],
      modal: {
        data: {
          order: {} as Order,
          menu_options: undefined,
        },
        errors: {
          order: {},
        },
      },

      errors: "",
      mode: "",
      isLoading: false,
      // ODR-1629: 注文確定時にサーバーが返した在庫不足一覧
      shortage: { menus: [], options: [] } as StockShortage,
      // ODR-1700: サーバーが返した「最低注文人数に満たない商品」一覧（確認モーダル用）
      minCustomer: [] as MinCustomerViolation[],
      // ODR-1629: 注文中に承知した在庫を累積して毎回まとめて送る（不足の再燃ループ防止）
      // 注文中の全商品の現在在庫スナップショット（サーバーの stock）。echo兼カート行の不足表示に使う
      stockInfo: { menus: {}, options: {} } as Acknowledged,

      staffId: store.state.staff.id,
      langKey: store.state.langKey,
      // ODR-1649 C007: 通知ポップアップ(NotificationCategoryOption.vue)と同じ形で持つ。
      // Order をそのまま入れると Order.order_id(親オーダーID) と order_id(この行の注文ID)が衝突する。
      matchedOrders: [] as MatchedOrderRow[],
      // ODR-1649 C006: サーバー(order() の category_option)が組み立てたものをそのまま持つ
      categoryOptions: [] as CategoryOptionRow[],
    };
  },
  computed: {
    prefix() {
      return this.$route.params.prefix;
    },
    shoppix() {
      return this.$route.params.shoppix;
    },
    totalQuantity(): number {
      let target = this.listTotal.find(
        (listTotal) => listTotal.tax_rate == null
      );

      // listTotal は fetchOrders() の応答で埋まるため、初回レンダリング時は必ず空。
      // 合計行が無い状態を 0 として扱わないと undefined.quantity で描画が落ちる。
      if (!target) {
        return 0;
      }

      return target.quantity;
    },
    totalPrice(): number {
      let total = 0;
      for (const order of this.orders) {
        if (order.prices.total.exclude !== null) {
          total += order.prices.total.exclude;
        } else {
          total += order.prices.total.include;
        }
      }

      return total;
    },
    taxType(): string {
      if (this.isNaizei === true) {
        return " (" + translate("hall-0096", "税込") + ")";
      }
      if (this.isNaizei === false) {
        return " (" + translate("hall-0097", "税抜") + ")";
      }

      return "";
    },
    onLoadDisable() {
      if (this.isLoading) {
        return "disabled";
      } else {
        return "";
      }
    },
    isModalDone(): boolean {
      return this.mode === "done";
    },
    isModalOption(): boolean {
      return this.mode === "option";
    },
    isModalReceive(): boolean {
      return this.mode === "receive";
    },
    isModalCategoryOption(): boolean {
      return this.mode === "category_option";
    },
    isModalShortage(): boolean {
      return this.mode === "shortage";
    },
    // ODR-1700: 人数不足の確認モーダル
    isModalMinCustomer(): boolean {
      return this.mode === "min_customer";
    },
  },
  mounted() {
    api.set_token(store.state.token);
    this.fetchOrders();
  },
  methods: {
    handleClickIncrease() {
      if (this.isLoading) {
        return;
      }

      this.updateQuantity(+1);
    },
    handleClickDecrease() {
      if (this.isLoading) {
        return;
      }

      this.updateQuantity(-1);
    },
    handleClickModifyOrder(item) {
      if (this.isLoading) {
        return;
      }

      this.mode = "option";
      this.modal.data.menu_options = item.menu.menu_options;
      this.modal.data.order = _.cloneDeep(item);
    },
    handleClickOrder() {
      if (this.isLoading) {
        return;
      }
      // ODR-1629: 新規の注文確定なので在庫スナップショット(不足表示)をリセット
      this.stockInfo = { menus: {}, options: {} };
      // ODR-1612: 受け取り方法の選択は配膳型のみ。セルフ型はお客様が厨房まで
      // 取りに来るので選択の余地がなく、モーダルを出さずそのまま注文確定する
      // （is_deliver は初期値 "0" ＝「取りに行く」のまま送られる）。
      if (store.state.shopSetting.is_select_receive && store.state.shopSetting.has_guide) {
        this.mode = "receive";
      } else {
        this.isLoading = true;
        this.order(this.stockInfo);
      }
    },
    handleClickOrderReceive() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.order(this.stockInfo);
    },
    handleClickSubmitModify() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.submitModify();
    },
    handleClickCloseModal() {
      if (this.isLoading) {
        return;
      }

      this.closeModal();
    },
    handleClickSubmitDelete() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.submitDelete();
    },
    handleClickStart: function () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.startCategoryOption();
    },

    updateQuantity(offset) {
      const quantity = Math.max(1, this.modal.data.order.quantity + offset);
      this.modal.data.order.quantity = quantity;
    },
    optionValueRadio(option_menu) {
      const result = _.find(
        this.modal.data.order.tmp_options,
        function (row: TmpOrder) {
          if (!row.menus_menu_option) {
            return false;
          }
          return option_menu.id === row.menus_menu_option.id;
        }
      );
      return result ? true : false;
    },
    optionValueCheckbox(option_menu) {
      const result = _.findIndex(
        this.modal.data.order.tmp_options,
        function (row: TmpOrder) {
          return option_menu.id === row.menus_menu_option_id;
        }
      );
      return result !== -1;
    },
    optionChangeRadio(event, option) {
      _.remove(this.modal.data.order.tmp_options, function (row: TmpOrder) {
        if (!row.menus_menu_option) {
          return false;
        }
        return option.id === row.menus_menu_option.menu_option_id;
      });
      this.modal.data.order.tmp_options.push({
        menus_menu_option_id: _.clone(event.target.value),
        menus_menu_option: {
          menu_option_id: option.id,
        },
        quantity: this.modal.data.order.quantity,
      });
    },
    optionChangeCheckbox(event, option) {
      if (!event.target.checked) {
        const result = _.findIndex(
          this.modal.data.order.tmp_options,
          function (row: TmpOrder) {
            return event.target.value === row.menus_menu_option_id;
          }
        );
        if (result !== -1) {
          this.modal.data.order.tmp_options.splice(result, 1);
        }
      } else {
        this.modal.data.order.tmp_options.push({
          menus_menu_option_id: _.clone(event.target.value),
          menus_menu_option: {
            menu_option_id: option.id,
          },
          quantity: this.modal.data.order.quantity,
        });
      }
    },
    closeModal() {
      this.mode = "";
      this.isLoading = false;
      this.isDeliver = "0";
      this.modal.data.order = {};
    },
    redirectToCheck() {
      this.$router.push(
        `/${this.prefix}/${this.shoppix}/table-session/check-quick/${this.tableSessionId}`
      );
    },
    redirectToHome() {
      this.$router.push(`/${this.prefix}/${this.shoppix}/home`);
    },

    order(acknowledged = { menus: {}, options: {} }, acknowledgedMinCustomer = false) {
      if (this.isQuick === true) {
        this.redirectToCheck();
        return;
      }

      let message = "";
      api
        .order_order({
          code: OrderCode.CODE_BY_HALLSTAFF,
          id: this.tableSessionId,
          staff_id: this.staffId,
          is_deliver: this.isDeliver,
          acknowledged,
          // ODR-1700: 人数不足を確認済みなら true で再送する（サーバーはこの時だけ強行を許す）
          acknowledged_min_customer: acknowledgedMinCustomer,
        })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          if (response.data.orders.length > 0) {
            this.applyCategoryOption(response.data.category_option);
          }
        })
        .catch((err) => {
          const res = err.response && err.response.data;
          // ODR-1629: 在庫不足(enough)なら、エラー通知ではなく確認モーダルを開く
          if (res && res.status === "enough" && res.data) {
            // ODR-1629: 不足一覧(モーダル表示用) と 注文中の全商品の現在在庫(echo兼カート行の不足表示用) を保持
            this.shortage = res.data.shortage || { menus: [], options: [] };
            this.stockInfo = res.data.stock || { menus: {}, options: {} };
            this.mode = "shortage";
            return;
          }
          // ODR-1700: 最低注文人数に満たない(min_customer)なら、確認モーダルを開く
          if (res && res.status === "min_customer" && res.data) {
            this.minCustomer = res.data.min_customer || [];
            this.mode = "min_customer";
            return;
          }
          message =
            (res && res.message) ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // ODR-1700: 人数不足の確認モーダル「このまま注文する」= 人数不足を承知で強行
    handleClickForceMinCustomerOrder() {
      if (this.isLoading) {
        return;
      }
      this.mode = "";
      this.isLoading = true;
      // 在庫の確認状態(stockInfo)も引き継いで再送する
      this.order(this.stockInfo, true);
    },
    // ODR-1700: 人数不足の確認モーダル「戻って修正」= モーダルを閉じ、人数変更やカート修正をさせる
    handleClickCancelMinCustomer() {
      this.mode = "";
    },
    // ODR-1629: 確認モーダル「このまま注文する」= 不足を承知で強行（全商品スナップショットを echo）
    handleClickForceOrder() {
      if (this.isLoading) {
        return;
      }
      this.mode = "";
      this.isLoading = true;
      this.order(this.stockInfo);
    },
    // ODR-1629: 確認モーダル「戻って修正」= モーダルを閉じ、カート画面で数量変更/削除させる。
    // stockInfo は保持し、各行に不足数(menuStockWarn)を表示し続ける。
    handleClickCancelShortage() {
      this.mode = "";
    },
    // ODR-1629: カート行の menu の在庫状態（売り切れ / 不足数）。
    // 数量変更で this.orders が更新されると自動で再計算される。
    menuStockWarn(order) {
      const s = this.stockInfo.menus[order.menu_id];
      if (!s) {
        return null;
      }
      if (s.is_soldout) {
        return { soldout: true };
      }
      if (s.is_set_maximum_order_per_day) {
        const total = this.orders
          .filter((o) => o.menu_id === order.menu_id)
          .reduce((a, o) => a + o.quantity, 0);
        const short = total - s.remain_order;
        if (short > 0) {
          return { short: short };
        }
      }
      return null;
    },
    // ODR-1629: カート行のオプション(トッピング等)の在庫不足。tmp_options[].menu_id を
    // stockInfo.options のキーに突合。数量は同じオプションメニューを全行合計して判定する。
    optionStockWarns(order) {
      const result = [];
      (order.tmp_options || []).forEach((opt) => {
        const optMenuId = opt.menu_id;
        const s = this.stockInfo.options[optMenuId];
        if (!s) {
          return;
        }
        const name = opt.menu_name || (opt.menu && opt.menu.name) || "";
        if (s.is_soldout) {
          result.push({ name: name, soldout: true });
          return;
        }
        if (s.is_set_maximum_order_per_day) {
          const total = this.orders.reduce((sum, o) => {
            return (
              sum +
              (o.tmp_options || [])
                .filter((t) => t.menu_id === optMenuId)
                .reduce((a, t) => a + t.quantity, 0)
            );
          }, 0);
          const short = total - s.remain_order;
          if (short > 0) {
            result.push({ name: name, short: short });
          }
        }
      });
      return result;
    },
    submitModify() {
      let message = "";
      api
        .order_edit_tmp({ order: this.modal.data.order })
        .then((response) => {
          message = response.data.message;
          this.showSuccessNotification(message);
          this.closeModal();
          this.fetchOrders();
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.modal.errors.order = message;
          this.isLoading = false;
        });
    },
    submitDelete() {
      let message = "";
      api
        .order_delete_tmp({ order: this.modal.data.order })
        .then((response) => {
          message = response.data.message;
          this.showSuccessNotification(message);
          this.closeModal();
          this.fetchOrders();
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.modal.errors.order = message;
          this.isLoading = false;
        });
    },
    /**
     * ODR-1649 C006: 飲み放題ポップアップの内容はサーバー(order() のレスポンス)が組み立てる。
     * フロントは受け取った categoryOptions / matchedOrders を表示するだけにする。
     * 以前はここで抽出ロジックを再実装しており、バックエンド側と二重管理になっていた。
     *
     * @param {Object} categoryOption - order() レスポンスの category_option
     */
    applyCategoryOption(categoryOption) {
        const categoryOptions = (categoryOption && categoryOption.categoryOptions) || [];
        const matchedOrders = (categoryOption && categoryOption.matchedOrders) || [];

        if (categoryOptions.length === 0) {
          // 飲み放題メニューがない場合は通常の完了ポップアップ
          this.mode = "done";
          return;
        }

        this.categoryOptions = categoryOptions;

        // 既存オーダーがある場合、または手動開始の飲み放題がある場合はポップアップを表示
        const hasManualStartOption = categoryOptions.some(option => !option.is_auto_start);

        if (matchedOrders.length > 0 || hasManualStartOption) {
          this.mode = "category_option";
          this.matchedOrders = matchedOrders;
        } else {
          // 全て自動開始で既存オーダーがない場合は通常の完了ポップアップ
          this.mode = "done";
        }
    },
    startCategoryOption() {
      let message = "";
      const matchedOrdersData = toMatchedOrdersPayload(this.matchedOrders);
      api
        .start_category_option({
            table_session_id: this.tableSessionId,
            matched_orders: matchedOrdersData,
            category_options: this.categoryOptions,
        })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          this.mode = "done";
          this.isLoading = false;
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translate("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
          this.isLoading = false;
        });
    },

    fetchOrders() {
      this.isLoading = true;
      let message = "";
      api
        .hallCart({ lang: this.langKey, table_session_id: this.tableSessionId })
        .then((response) => {
          if (response.data.status !== "success") {
            message =
              response.data.message ||
              translate("hall-0048", "データの取得に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          this.isLoading = false;
          if (
            response.data.data.isQuick === true &&
            response.data.data.orders.length === 0
          ) {
            this.redirectToHome();
            return;
          }
          this.orders = response.data.data.orders;
          this.isNaizei = response.data.data.isNaizei;
          this.isQuick = response.data.data.isQuick;
          this.listTotal = response.data.data.listTotal;
        })
        .catch((err) => {
          this.isLoading = false;
          message =
            err.response.data.message ||
            translate("hall-0048", "データの取得に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
        });
    },
    orderItemStyle(order) {
      if (order.quantity === 0) {
        return { opacity: 0.5 };
      } else {
        return {};
      }
    },
    numberFormat(number) {
      if (typeof number !== "number" || isNaN(number)) {
        return 0;
      }
      return number.toLocaleString();
    },
  },
});
